

























import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import HalfNumbersConverter from "@/helpers/HalfNumbersConverter";

const rePostcode = /^[0-9]{3}-[0-9]{4}$/;
const converter = new HalfNumbersConverter();

@Component({
  props: {
    required: {
      type: Boolean,
      default: false
    }
  }
})
export default class InputPhoneNumber extends Vue {
  @Prop({ default: "" }) id!: string;
  @Prop({ default: "" }) name!: string;
  @Prop({ default: "" }) value!: string;

  get part1(): string {
    return this.value.split("-")[0];
  }

  set part1(part1: string) {
    this.input(converter.convert(part1), this.part2);
  }

  get part2(): string {
    const s = this.value.split("-");
    if (s.length < 2) return "";
    return s[1];
  }

  set part2(part2: string) {
    this.input(this.part1, converter.convert(part2));
  }

  @Watch("value")
  validate() {
    const i = this.$refs.main as HTMLInputElement;
    if (this.value && !rePostcode.test(this.value)) {
      i.setCustomValidity("間違った形式です。\n例: 000-0000");
    } else {
      i.setCustomValidity("");
    }
  }

  input(p1: string, p2: string) {
    if (p1 || p2) {
      this.$emit("input", `${p1}-${p2}`);
    } else {
      this.$emit("input", "");
    }
    // 同じ数字が全角で入ってきた際に更新されないので強制的に更新する
    this.$nextTick(() => {
      this.$forceUpdate();
    });
  }
}
